import { Pipe, PipeTransform } from '@angular/core';
import { ISerie } from '../models/seriesInfo.interfaces';
import { DecimalPipe } from '@angular/common';
import * as moment from 'moment';

@Pipe({
  name: 'getSerieValue'
})
export class GetSerieValuePipe implements PipeTransform {

  constructor(private _decimalPipe: DecimalPipe) {}
  
  transform(serie: ISerie, customUnit?: string): string {
    const value = serie.lastValue;

    // 1. Check if value exists (0 is allowed)
    if (value === null || value === undefined) {
      return ' -';
    }

    // 2. Check range limits if provided
    const min = serie.min ?? -Infinity;
    const max = serie.max ?? Infinity;
    if (value < min || value > max) {
      return ' -';
    }

    // 3. Check communication tolerance if date is present
    if (serie.date) {
      const toleranceSeconds = serie.communicationTolerance ?? 86400;
      const threshold = moment().subtract(toleranceSeconds, 'seconds');
      if (moment(serie.date).isBefore(threshold)) {
        return ' -';
      }
    }

    // 4. Format number
    const decimalPlacesValue = serie.decimalPlaces !== undefined
      ? this._decimalPipe.transform(value, `1.${serie.decimalPlaces}-${serie.decimalPlaces}`, 'en')
      : this._decimalPipe.transform(value, '1.1-1', 'en');

    if (decimalPlacesValue === null) {
      return ' -';
    }

    // 5. Append unit
    const unit = serie.unit !== 'º' ? ` ${serie.unit}` : serie.unit;
    return customUnit
      ? `${decimalPlacesValue} ${customUnit}`
      : `${decimalPlacesValue}${unit}`;
  }
}
